class SiteActionCloseRefresh
    extends SiteAction {

    private readonly _action: IActionType;
    private readonly _card: ISiteCard;

    constructor(card: ISiteCard, action: IActionType, next: SiteAction | null) {
        super(next);
        this._action = action;
        this._card = card;
    }
    async _execute() {
        let prevCard = this._card.prev<SiteCard>();
        if (prevCard == null)
            return false;
        
        await this._card.Container.removeCard(this._card);
        return await prevCard.refresh();
    }
}